const PackageSkeleton = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 py-6 animate-pulse">

            {/* Title */}
            <div className="h-7 w-2/3 bg-gray-200 rounded mb-2"></div>
            <div className="h-4 w-1/3 bg-gray-200 rounded mb-6"></div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

                {/* LEFT IMAGE SECTION */}
                <div className="lg:col-span-2">
                    <div className="w-full h-[380px] bg-gray-200 rounded-xl"></div>
                </div>

                {/* RIGHT PRICE CARD */}
                <div className="bg-gray-100 rounded-xl p-5 space-y-4">

                    <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
                    <div className="h-8 w-2/3 bg-gray-200 rounded"></div>

                    <div className="h-12 w-full bg-gray-300 rounded-lg"></div>

                    <div className="space-y-3 pt-2">
                        <div className="flex items-center gap-3">
                            <div className="h-5 w-5 bg-gray-200 rounded-full"></div>
                            <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
                        </div>

                        <div className="flex items-center gap-3">
                            <div className="h-5 w-5 bg-gray-200 rounded-full"></div>
                            <div className="h-4 w-2/3 bg-gray-200 rounded"></div>
                        </div>
                    </div>

                    {/* Icons row */}
                    <div className="grid grid-cols-4 gap-4 pt-4">
                        {[...Array(4)].map((_, i) => (
                            <div key={i} className="h-10 bg-gray-200 rounded"></div>
                        ))}
                    </div>
                </div>
            </div>

            {/* TABS */}
            <div className="flex gap-6 mt-8 border-b">
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="h-5 w-32 bg-gray-200 rounded"></div>
                ))}
            </div>

            {/* CONTENT SECTION */}
            <div className="mt-6 space-y-3">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="h-4 w-full bg-gray-200 rounded"></div>
                ))}
            </div>
        </div>
    );
};

export default PackageSkeleton;